/**
 * 이상한 방 - 단계 이름·힌트 문구 (사전이 이기고, 없으면 넘어온 값)
 *
 * ## 규칙은 하나다
 *
 * `levels.ts`는 아직 한국어 이름과 힌트를 직접 들고 있다(`LevelDef.name`·`hint`). 화면은 그 값을
 * 그대로 쓰지 않고 사전의 `level.<id>.name`·`level.<id>.hint`를 먼저 본다. 그래야 영어 화면에서도
 * 단계 이름이 번역되고, 사전에 키가 없는 단계(튜닝용으로 하나 끼워 넣은 경우)에서는
 * `[[level.11.name]]`이 아니라 넘어온 값이 그대로 나온다.
 *
 * ## 왜 따로 떼어 냈는가
 *
 * 같은 규칙이 `levelSelect.ts`와 `resultScreen.ts`에 한 벌씩 있었다. 결과 화면은 선택 화면 없이도
 * 서야 하고(자유 모드에서는 선택 화면이 아예 뜨지 않는다), 선택 화면을 import하면 그 CSS까지
 * 따라오기 때문에 복사한 것이었다. 이 파일은 `i18n`만 import하고 CSS가 없으므로 어느 화면이든
 * 부담 없이 부른다. 인자를 `LevelSelectLevel` 같은 화면 타입이 아니라 번호와 폴백 문자열로 받는
 * 이유도 같다 - 화면 타입을 알면 화면에 묶인다.
 *
 * ## 폴백은 죽은 경로다
 *
 * `i18n/index.test.ts`가 `LEVELS`의 모든 id에 대해 두 사전에 키가 있음을 고정한다. 정식 단계에서
 * 폴백 가지를 밟는 일은 없고, 밟히는 순간 그 테스트가 먼저 실패한다. 폴백을 남겨 두는 이유는
 * 위의 "튜닝용 단계"뿐이다.
 */

import { hasKey, t } from '../i18n'

/** 단계 이름. 사전에 `level.<id>.name`이 있으면 그것, 없으면 `fallback`. */
export function levelNameOf(levelId: number, fallback: string): string {
  const key = `level.${levelId}.name`
  return hasKey(key) ? t(key) : fallback
}

/** 단계 힌트. 규칙은 이름과 같다. */
export function levelHintOf(levelId: number, fallback: string): string {
  const key = `level.${levelId}.hint`
  return hasKey(key) ? t(key) : fallback
}
